"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isValidType(type, allowArray) {
    return (typeof type === 'string' ||
        typeof type === 'symbol' ||
        (!!allowArray &&
            Array.isArray(type) &&
            type.every(function (t) { return isValidType(t, false); })));
}
exports.default = isValidType;



//////////////////
// WEBPACK FOOTER
// ../~/react-dnd/lib/cjs/utils/isValidType.js
// module id = 1086
// module chunks = 1